/// <reference path="../../services/dashboard.service.js" />
const mod = require('../../bahabot.module.js')

/**
 * @param {DashboardService} DashboardService
 */
function bbDashboardController(DashboardService) {
    this.svc = DashboardService;

    this.data = {
        overview: {}
    };

    this.loading = {
        overview: true,
    };

    this.chartJSOptionsActivityTypes = {
        type: 'doughnut',
        data: {
            labels: [
                "Redeems",
                "Follows",
                "Raids",
                "Bits",
                "Subs",
                "Badwords",
                "Words",
                "Commands"
            ],
            datasets: [
                {
                    label: "Tracked Entities",
                    backgroundColor: [
                        "#34d399", // Redeems
                        "#60a5fa", // Follows
                        "#f472b6", // Raids
                        "#facc15", // Bits
                        "#818cf8", // Subs
                        "#f87171", // Badwords
                        "#38bdf8", // Words
                        "#a78bfa"  // Commands
                    ],
                    data: [0,0,0,0,0,0,0,0],
                    hoverOffset: 8
                },
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    position: "top"
                },
                title: {
                    display: true,
                    text: "Tracked Entities"
                }
            }
        }
    }

    this.chartJSOptionsActivityOverTime = {
        type: 'line',
        data: {
            labels: [],
            datasets: [
                {
                    label: 'Activity count',
                    data: [],
                    borderColor: '#10b981',
                    backgroundColor: 'rgba(16, 185, 129, 0.2)', // e.g., sky-400 with 20% opacity
                    fill: true,
                    cubicInterpolationMode: 'monotone',
                    tension: 0.4
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                title: {
                    display: true,
                    text: "Tracked activities by day"
                }
            },
            interaction: {
                intersect: false,
            },
            scales: {
                x: {
                    display: true,
                    title: {
                        display: true
                    },
                },
                y: {
                    display: true,
                    title: {
                        display: true,
                        text: 'Value'
                    },
                    suggestedMin: 0,
                    suggestedMax: 20,
                }
            }
        }
    };

    const timezoneOffset = new Date().getTimezoneOffset();
    DashboardService.get(timezoneOffset).then(r => {
        this.data.overview = r;

        if (this.data.overview.activityGraph) {
            this.chartJSOptionsActivityOverTime.data.labels = this.data.overview.activityGraph.map(g => {
                // format the date while we're here
                return g.date.split("T").shift()
            });
            this.chartJSOptionsActivityOverTime.data.datasets[0].data = this.data.overview.activityGraph.map(g => g.count);    
        }

        const actStats = this.data.overview.activitiesStats ?? {};
        const bwStats = this.data.overview.badwordStats ?? {};
        const wStats = this.data.overview.wordStats ?? {};
        const cmdStats = this.data.overview.commandStats ?? {};

        const combinedStats = {...actStats, ...bwStats, ...wStats, ...cmdStats};
        for (const key in combinedStats) {
            const idx = this.chartJSOptionsActivityTypes.data.labels.indexOf(key.replace("total", ""));
            if (idx > -1) {
                this.chartJSOptionsActivityTypes.data.datasets[0].data[idx] = combinedStats[key];
            } else if (key === 'totalActivities') {
                const totalCount = combinedStats[key] + (bwStats.totalBadwords ?? 0) + (wStats.totalWords) + (cmdStats.totalCommands ?? 0);
                this.chartJSOptionsActivityTypes.options.plugins.title.text = `Tracked Entities (${totalCount} total)`;
            }
        }
    })

    this.hasActivityTypeData = function() {
        if (!this.chartJSOptionsActivityTypes.data.datasets.length) return false;
        for (let i = 0; i < this.chartJSOptionsActivityTypes.data.datasets[0].data.length; i++) {
            if (this.chartJSOptionsActivityTypes.data.datasets[0].data[i] > 0) return true;
        }
        return false;
    }
}

mod.component('bbDashboard', {
    templateUrl: 'tpl/bb-dashboard.component.html',
    bindings: {},
    controller: ["DashboardService", bbDashboardController]
});